import "./Navbar.css";
import logo from '../assets/cloudcallLogo.png';
import { useEffect, useState } from "react";

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 12);
    };

    handleScroll();
    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const closeMenu = () => {
    setIsOpen(false);
  };

  return (
    <>
      <header className={`navbar ${scrolled ? "scrolled" : ""}`}>
        <div className="container nav-container">

          <div className="logo">
            <img src={logo} alt="cloud-call-logo" />
          </div>

          {/* Hamburger Menu Button - pushed to right with margin-left: auto */}
          <button
            className={`hamburger ${isOpen ? 'active' : ''}`}
            onClick={toggleMenu}
            aria-label="Toggle menu"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>

          <nav>
            <ul className={`nav-links ${isOpen ? 'active' : ''}`}>
              <li>
                <a href="/" onClick={closeMenu}>HOME</a>
              </li>

              {/* <li>
                <a href="/about" onClick={closeMenu}>ABOUT</a>
              </li> */}

              <li>
                <a href="/features" onClick={closeMenu}>FEATURES</a>
              </li>

              {/* <li>
                <a href="/industries" onClick={closeMenu}>INDUSTRY USE CASES</a>
              </li>

              <li>
                <a href="/faq" onClick={closeMenu}>FAQ</a>
              </li> */}

                <li>
                  <a href="/contact" onClick={closeMenu}>CONTACT</a>
                </li>

                <li>
                  <a className="demo-btn" href="/demo" onClick={closeMenu}>
                    REQUEST A DEMO
                  </a>
                </li>
            </ul>
          </nav>

        </div>
      </header>

      {/* Overlay for mobile menu */}
      <div
        className={`nav-overlay ${isOpen ? 'active' : ''}`}
        onClick={closeMenu}
      ></div>
    </>
  );
}